import {
  Bug,
  CircleAlert,
  Cpu,
  Crown,
  Database,
  Globe,
  KeyRound,
  ScrollText,
  ShieldAlert,
  SlidersHorizontal,
  UserCog,
  Waypoints,
} from 'lucide-react';
import { CATEGORICAL_COLORS, SEVERITY_COLORS } from '@root/utilities/pastelColors';

// The badges under the attack path nodes: a FinOpsVisualizerGraph glyph key and its colour per risk.
export const RISK_SIGNALS = {
  internet_ingress: { label: 'Internet ingress', glyph: 'lucide-globe', color: CATEGORICAL_COLORS.lightBlue },
  vulnerabilities: { label: 'Other vulnerabilities', glyph: 'lucide-bug', color: SEVERITY_COLORS.high },
  in_use: { label: 'Package in use', glyph: 'lucide-circle-play', color: SEVERITY_COLORS.success },
  fixable: { label: 'Fix available', glyph: 'lucide-wrench', color: CATEGORICAL_COLORS.amber },
  known_exploit: { label: 'Known exploit', glyph: 'lucide-circle-alert', color: SEVERITY_COLORS.critical },
};

// The icon and colour of each item type the resource risk API returns, for the Resource risk analysis lines.
// Same types as the inventory overview's Risk Analysis card.
export const RESOURCE_RISK_TYPES = {
  exposure: { label: 'Internet exposure', icon: Globe, color: CATEGORICAL_COLORS.lightBlue },
  threat: { label: 'Active threats', icon: ShieldAlert, color: SEVERITY_COLORS.critical },
  threat_story: { label: 'Threat stories', icon: ScrollText, color: SEVERITY_COLORS.high },
  vulnerability: { label: 'Vulnerabilities', icon: Bug, color: SEVERITY_COLORS.high },
  configuration: { label: 'Misconfigurations', icon: SlidersHorizontal, color: CATEGORICAL_COLORS.amber },
  secret: { label: 'Exposed secrets', icon: KeyRound, color: SEVERITY_COLORS.critical },
  privilege: { label: 'Privileged access', icon: UserCog, color: CATEGORICAL_COLORS.purple },
  imds: { label: 'Instance metadata', icon: Cpu, color: CATEGORICAL_COLORS.mutedBlue },
  database: { label: 'Database', icon: Database, color: CATEGORICAL_COLORS.purple },
  attack_path: { label: 'Attack paths', icon: Waypoints, color: SEVERITY_COLORS.critical },
  crown_jewel: { label: 'Crown jewel', icon: Crown, color: CATEGORICAL_COLORS.amber },
};

// A type the API adds later still gets a line, labelled from its key.
export const getResourceRiskType = type =>
  RESOURCE_RISK_TYPES[type] ?? {
    label: (type ?? '').replaceAll('_', ' ').replace(/^\w/, letter => letter.toUpperCase()),
    icon: CircleAlert,
    color: CATEGORICAL_COLORS.mutedBlue,
  };

export const severityColor = severity => SEVERITY_COLORS[severity?.toLowerCase()] ?? SEVERITY_COLORS.other;
